import { Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FormContainer = styled("form")(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  width: 300,
  maxWidth: "100%",
  padding: theme.spacing(2),
  gap: theme.spacing(1),
}));

export const Section = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
}));

export const SectionHeader = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
}));

export const InfoIconWrapper = styled("span")(({ theme }) => ({
  display: "inline-flex",
  color: theme.palette.text.secondary,
}));

export const PriceChangeRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1),

  "& .MuiTextField-root": {
    flex: 1,
    minWidth: 0,
  },
}));

export const ToggleGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  gap: theme.spacing(0.75),
  flexWrap: "wrap",

  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: "999px !important",
    margin: 0,
  },
}));

export const PillButton = styled(ToggleButton)(({ theme }) => ({
  height: 30,
  minWidth: 44,
  padding: theme.spacing(0, 1.25),
  borderRadius: 999,
  textTransform: "none",
  whiteSpace: "nowrap",
}));
